import { render, staticRenderFns } from "./HeartRateNomalData.vue?vue&type=template&id=4da42cd6&scoped=true&"
import script from "./HeartRateNomalData.vue?vue&type=script&lang=js&"
export * from "./HeartRateNomalData.vue?vue&type=script&lang=js&"
import style0 from "./HeartRateNomalData.vue?vue&type=style&index=0&id=4da42cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da42cd6",
  null
  
)

export default component.exports